import { useState, useCallback } from 'react';

/**
 * Custom hook for managing selection state in Ampol Cash Order Modal
 *
 * Manages:
 * - Form ID state (which form is currently active)
 * - Cart validation state
 * - Cart item UUID selection
 * - Recipient UUID selection
 * - Delivery options validation
 *
 * @param cashOrderCartItems - Current cart items from Redux
 * @returns Selection state and setter functions
 */
export const useAmpolCashOrderSelection = (cashOrderCartItems) => {
  // Form management
  const [formId, setFormId] = useState(null);

  // Cart validation
  const [isCartItemsValid, setIsCartItemsValid] = useState(false);
  const hasCartItems = Object.keys(cashOrderCartItems || {}).length > 0;

  // Selection tracking
  const [cartItemUuid, setCartItemUuid] = useState(null);
  const [recipientUuid, setRecipientUuid] = useState(null);

  // Delivery validation
  const [isDeliveryOptionsValid, setIsDeliveryOptionsValid] = useState(true);

  // Convenience methods for setting selection
  const selectCartItem = useCallback((uuid) => {
    setCartItemUuid(uuid);
    setRecipientUuid(null); // Reset recipient when selecting new cart item
  }, []);

  const selectRecipient = useCallback((uuid) => {
    setRecipientUuid(uuid);
  }, []);

  const resetSelection = useCallback(() => {
    setCartItemUuid(null);
    setRecipientUuid(null);
  }, []);

  return {
    // Form state
    formId,
    setFormId,

    // Cart state
    isCartItemsValid,
    setIsCartItemsValid,
    hasCartItems,

    // Selection state
    cartItemUuid,
    setCartItemUuid,
    recipientUuid,
    setRecipientUuid,

    // Delivery validation
    isDeliveryOptionsValid,
    setIsDeliveryOptionsValid,

    // Convenience methods
    selectCartItem,
    selectRecipient,
    resetSelection,
  };
};
